<script>
import { Line, mixins } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes'
import 'chartjs-adapter-date-fns'
import { Tableau20 } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau'
import { dateLocales } from '../../plugins/dateLocales'

import Vuetify from '../../plugins/vuetify'

export default {
  name: 'LineChart',
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    xLabel: String,
    yLabel: String
  },
  computed: {
    options () {
      return {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            fill: false
          }
        },
        scales: {
          xAxes: [{
            type: 'time',
            adapters: {
              date: {
                locale: dateLocales[Vuetify.framework.lang.current]
              }
            },
            time: {
              tooltipFormat: 'yyyy-MM-dd HH:mm',
              displayFormats: {
                quarter: 'MMM YYYY',
                minute: Vuetify.framework.lang.current === 'ru' ? 'HH:mm' : 'hh:mm A',
                hour: Vuetify.framework.lang.current === 'ru' ? 'HH:mm' : 'hh:mm A'
              }
            },
            distribution: 'series',
            scaleLabel: {
              display: true,
              labelString: this.xLabel
            }
          }],
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: this.yLabel
            }
          }]
        },
        plugins: {
          colorschemes: {
            scheme: Tableau20
          }
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped>

</style>
